import { classNames } from "@/lib/format";
import type { OnlineBookingSubSectionDef } from "@/pages/stammdaten/online-booking/onlineBookingSubSections";

interface OnlineBookingSubSectionNavProps {
  sections: OnlineBookingSubSectionDef[];
  activeSection: OnlineBookingSubSectionDef["id"];
  onSection: (section: OnlineBookingSubSectionDef["id"]) => void;
}

export function OnlineBookingSubSectionNav({
  sections,
  activeSection,
  onSection,
}: OnlineBookingSubSectionNavProps) {
  return (
    <nav
      aria-label="Unterbereiche"
      className="flex gap-1 overflow-x-auto overscroll-x-contain rounded-lg border border-separator/80 bg-fill-quaternary p-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      role="tablist"
    >
      {sections.map((section) => {
        const isActive = activeSection === section.id;
        return (
          <button
            key={section.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            title={section.description}
            className={classNames(
              "shrink-0 rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
              isActive
                ? "bg-card text-label shadow-sm ring-1 ring-separator/60"
                : "text-label-secondary hover:bg-fill hover:text-label",
            )}
            onClick={() => onSection(section.id)}
          >
            <span className="hidden sm:inline">{section.label}</span>
            <span className="sm:hidden">{section.shortLabel}</span>
          </button>
        );
      })}
    </nav>
  );
}
